module.exports = __webpack_public_path__ + "public/Icons/close.png?9f1ae309";